<template>
  <div>
    <main class="main-wrapper">
      <div v-if="!postsLoading" class="post-tag">
        <a tag="span" href="/blog" class="blog" :class="{ 'current-page': !slugClicked && !pageNumberClicked }">BLOG</a>
        <mdc-text tag="span" class="slash"> {{ slugClicked || pageNumberClicked ? '/' : '' }}</mdc-text>
        <a v-if="slugClicked" :class="{ 'current-page': slugClicked }">{{ slugClicked | removeHythen }}</a>
        <a v-if="pageNumberClicked && !slugClicked" :class="{ 'current-page': resultPage }">PAGE {{ resultPage }}</a>
      </div>
      <h1 class="heading-text">DuoMe Blog
        <span v-if="slugClicked"> - {{ slugClicked | removeHythen }}</span>
        <!-- <img class="search-image"
          sizes="(max-width: 1000px) 400px, 800px"
          src="../static/img/search-icon.svg"
          @click="goToSearchPage()"
        /> -->
      </h1>
      <mdc-text tag="span" class="loading-posts" typo="caption" v-if="postsLoading">Loading...</mdc-text>
      <div class="pages-grid" ref="pages-grid">
        <article :ref="'page-card' + page.id + index" class="page-card " v-for="(page, index) in pages" :key="page.id + index">
          <a class="image-link" @click="gotoPage(page.slug)">
            <img class="image"
                sizes="(max-width: 1000px) 400px, 800px"
                :src="page.feature_image"
                :alt="page.title"
            />
          </a>
          <div class="page-card-content">
              <a class="page-card-content-link" @click="gotoPage(page.slug)">
                <header class="page-card-header">
                    <div @click.stop="gotoSlugPosts(page.primary_tag.slug)" v-if="page.primary_tag" class="page-card-primary-tag">{{page.primary_tag.name}}</div>
                    <h2 class="page-card-title">{{page.title}}</h2>
                </header>
                <section class="page-card-excerpt">
                    <p v-if="page.excerpt">{{ replaceUrl(page.excerpt) }}
                    </p>
                </section>
              </a>
              <footer class="page-card-meta">
                  <ul class="author-list">
                      <li class="author-list-item" v-for="author in page.authors" :key="author.id + author.name">
                        <a v-if="author.profile_image" class="static-avatar">
                          <img class="author-profile-image" :src="author.profile_image" :alt="author.name" />
                        </a>
                        <!--below line is doubtful to refer icons/avatar file and check -->
                        <a v-else class="static-avatar author-profile-image">{{ "icons/avatar" }}</a>
                      </li>
                  </ul>
                  <div class="page-card-byline-content">
                      <span v-if="page.authors && page.authors.length > 2">"Multiple authors"</span>
                      <span v-else class="author-name">
                        <a v-for="(author, index) in page.authors" :key="author.id + author.name + 'name'">{{author.name}}{{ index === page.authors.length - 1 ? '' : ', ' }}</a>
                      </span>
                      <span class="page-card-byline-date">
                        <time :datetime="page.published_at ">{{dateFormat(page.published_at)}}</time>
                      </span>
                  </div>
              </footer>
          </div>
        </article>
      </div>
      <div class="page-numbers" v-if="!postsLoading && !slugClicked">
        <mdc-text class="page-nav" v-if="resultPage !== 1" tag="span" typo="caption" @click="gotoPageNumber('prev')">Prev</mdc-text>
        <div class="number-text" v-for="index in totalPages" :key="'page' + index" @click.stop="gotoPageNumberPosts(index)">
          <mdc-text tag="span" typo="caption" class="text" :class="resultPage === index ? 'current-page' : ''">{{index}}</mdc-text>
        </div>
        <mdc-text class="page-nav" v-if="resultPage !== totalPages" tag="span" typo="caption" @click="gotoPageNumber('next')">Next</mdc-text>
      </div>
    </main>
  </div>
</template>

<script>
import * as ghost from './utils/ghost'
export default {
  data () {
    return {
      postsLoading: false,
      pages: [],
      resultPage: 1,
      totalPages: null,
      slugClicked: '',
      pageNumberClicked: ''
    }
  },
  filters: {
    removeHythen: function (value) {
      const removeHythenFromText = (text) => {
        return text.replace('-', ' ')
      }
      if (!value) return ''
      return removeHythenFromText(value.toString())
    },
    removeLinks: function (value) {
      const updateLinksInHTML = (html) => {
        const regex = /href\s*=\s*(['"])(https?:\/\/.+?)\1/ig
        let link
        while ((link = regex.exec(html)) !== null) {
          html = html.replace(link[2], 'javascript:void(0)')
        }
        return html
      }
      if (!value) return ''
      return updateLinksInHTML(value.toString())
    }
  },
  async mounted () {
    const pageNumberParam = new URLSearchParams(window.location.search).get('page')
    const slugParam = new URLSearchParams(window.location.search).get('tag')
    // eslint-disable-next-line no-undef
    if (pageNumberParam) {
      this.pageNumberClicked = pageNumberParam
      this.getAllPosts(pageNumberParam).then(() => {
        this.postsLoading = false
      })
    } else if (slugParam) {
      this.slugClicked = slugParam
      this.getAllPosts(1, slugParam).then(() => {
        this.postsLoading = false
      })
    } else {
      this.pageNumberClicked = 1
      this.getAllPosts(1).then(() => {
        this.postsLoading = false
      })
    }
  },
  methods: {
    async getAllPosts (pageNumber, slug) {
      this.postsLoading = true
      const result = await ghost.posts(pageNumber, slug)
      this.pages = [...result.posts]
      this.totalPages = result.meta && result.meta.pagination.pages
      this.resultPage = result.meta && result.meta.pagination.page
    },
    goToSearchPage () {
      window.location.href = '/blog/search'
    },
    gotoPage (slug) {
      window.location.href = '/blog/' + slug    
    },
    gotoPageNumberPosts (pageNumber) {
      window.location.href = '/blog/?page=' + pageNumber
    },
    gotoSlugPosts (slug) {
      window.location.href = '/blog/?tag=' + slug
    },
    replaceUrl (content) {
      if (content) {
        return content.replace(/\[.*\]/gm, '')
      }
    },
    dateFormat (date) {
      return new Date(date).toDateString().slice(4)
    },
    gotoPageNumber (from) {
      let pageNumber
      if (from === 'prev') {
        pageNumber = this.resultPage - 1
      } else {
        pageNumber = this.resultPage + 1
      }
      this.gotoPageNumberPosts(pageNumber)
    }
  },
  watch: {
    postsLoading: {
      handler () {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<style>
h1 {
  text-transform: capitalize;
  margin-top: 30px !important;
  margin-bottom: 5px !important;
}
.main-wrapper {
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
  position: relative;
  padding: 0 4vmin;
  top: 80px;
  padding-bottom: 80px;
  min-height: 100vh;
}
.loading-posts {
  margin: 10px 10px 10px 0;
  display: block;
  font-weight: 600;
}
.page-numbers {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
}
.page-numbers .number-text {
  cursor: pointer;
  margin-right: 5px;
}
.page-numbers .page-nav {
  font-weight: 800;
  cursor: pointer;
}
.page-numbers .page-nav:first-of-type {
  margin-right: 10px;
}
.page-numbers .page-nav:last-of-type {
  margin-left: 10px;
}
.page-numbers .text {
  color: #000000;
  font-weight: 800;
}
.page-numbers .text.current-page {
  color: #b10000;
  cursor: default;
}
.pages-grid {
  position: relative;
  display: grid;
  grid-gap: 4vmin;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 4vmin 0;
}
.page-card {
  position: relative;
  flex: 1 1 301px;
  display: flex;
  flex-direction: column;
  min-height: 220px;
  background-size: cover;
}
.image-link {
  position: relative;
  display: block;
  overflow: hidden;
  border-radius: 3px;
  cursor: pointer;
}
img.image {
  width: 100%;
  height: 200px;
  background: #c5d2d9 no-repeat 50%;
  -o-object-fit: cover;
  object-fit: cover;
}
.page-card-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.page-card-content-link {
  position: relative;
  display: block;
  color: #15171a;
  cursor: pointer;
}
.page-card-header {
  margin: 20px 0 0;
}
.page-card-primary-tag {
  margin: 0 0 .2em;
  color: #cc0000;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: .2px;
  text-transform: uppercase;
}
.page-card-title {
  margin: 0 0 .4em;
  font-size: 2.4rem;
  transition: color .2s ease-in-out;
  font-family: 'Lato', sans-serif;
}
.page-card-excerpt {
  max-width: 56em;
  color: #60757e;
}
.page-card-excerpt p {
  font-family: 'Nunito Sans';
  margin-bottom: 1em;
  display: -webkit-box;
  overflow-y: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-word;
  font-weight: 400; /**hybrid-teams.webflow.css is overriding with 600 hence adding in here */
}
.page-card-meta {
  display: flex;
  align-items: center;
  padding: 0;
}
.author-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 0 4px;
  padding: 0;
  list-style: none;
}
.author-list-item {
  position: relative;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
}
.static-avatar {
  display: block;
  overflow: hidden;
  margin: 0 0 0 -6px;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  box-shadow: 0 0 0 1px hsl(0deg 0% 100% / 20%);
  pointer-events: none;
  cursor: default;
}
.author-profile-image,
.avatar-wrapper {
  display: block;
  width: 100%;
  height: 100%;
  background: #e4eaed;
  border-radius: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.page-card-byline-content {
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  margin: 0 0 0 8px;
  color: #90a2aa;
  font-size: 1.4rem;
  line-height: 1.2em;
  font-weight: 400;
}
.page-card-byline-content span {
  margin: 0;
}
.page-card-byline-content .author-name {
  margin-bottom: 5px;
}
.page-card-byline-content a {
  font-size: 15px;
  color: #373c44;
  font-weight: 600;
  cursor: default;
}
.page-card-byline-date {
  line-height: 1.5em;
}
@media (max-width: 1000px) {
  .pages-grid {
      grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 700px) {
  .pages-grid {
    grid-template-columns: 1fr;
    grid-gap: 40px;
  }
}
.post-tag {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0;
  color: #738a94;
  font-size: 1.3rem;
  line-height: 1.4em;
  letter-spacing: .02em;
  font-weight: 600;
  position: relative;
}
.post-tag a {
  margin-right: 10px;
  font-weight: 800;
  color: #000000;
  cursor: pointer;
  text-transform: uppercase;
}
.post-tag a.current-page {
  color: #cc0000 !important;
  cursor: default;
  margin-left: 10px;
}
.post-tag .slash {
  font-weight: 800;
  color: #000000;
}
.heading-text {
  display: flex;
  flex-direction: row;
}
.search-image {
  width: 50px;
  height: 50px;
  margin-left: auto;
  cursor: pointer;
}
</style>
